/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Legacy
 * Mercatus Legacy ILM
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Filter } from '../model';
// @ts-ignore
import { GenerateMergeDocumentRequest } from '../model';
// @ts-ignore
import { InlineResponse20010 } from '../model';
// @ts-ignore
import { InlineResponse2003 } from '../model';
// @ts-ignore
import { InlineResponse2004 } from '../model';
/**
 * EntityApi - axios parameter creator
 * @export
 */
export const EntityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete details view
         * @param {Filter} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDetailsView: async (filter?: Filter, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/projectDetail/deleteDetailsView`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Does the generation of a merged document
         * @param {GenerateMergeDocumentRequest} [generateMergeDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMergeDocument: async (generateMergeDocumentRequest?: GenerateMergeDocumentRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/proposal/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateMergeDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details view data
         * @param {number} orgId 
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailsViews: async (orgId: number, entityTypeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getDetailsViews', 'orgId', orgId)
            // verify required parameter 'entityTypeId' is not null or undefined
            assertParamExists('getDetailsViews', 'entityTypeId', entityTypeId)
            const localVarPath = `/projectDetail/detailsFilterData/{orgId}/{entityTypeId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"entityTypeId"}}`, encodeURIComponent(String(entityTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads the merged document
         * @param {number} templateId TemplateId to use.
         * @param {number} entityId EntityId to use as the source of data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadMergeDocument: async (templateId: number, entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getDownloadMergeDocument', 'templateId', templateId)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getDownloadMergeDocument', 'entityId', entityId)
            const localVarPath = `/proposal/download/proposal/{entityId}/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of merged documents for the entity
         * @param {number} entityId EntityId to use as the source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergeDocumentsDownloadList: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getMergeDocumentsDownloadList', 'entityId', entityId)
            const localVarPath = `/proposal/list/project/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of template documents for the merge documents dialog
         * @param {number} entityTypeId EntityTypeId to use as the source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergeDocumentsTemplates: async (entityTypeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityTypeId' is not null or undefined
            assertParamExists('getMergeDocumentsTemplates', 'entityTypeId', entityTypeId)
            const localVarPath = `/proposal/proposalList?entityTypeId={entityTypeId}`
                .replace(`{${"entityTypeId"}}`, encodeURIComponent(String(entityTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validates the fields of merged documents for the entity
         * @param {number} templateId TemplateId to use.
         * @param {number} entityId EntityId to use as the source of data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMergeDocuments: async (templateId: number, entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('validateMergeDocuments', 'templateId', templateId)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('validateMergeDocuments', 'entityId', entityId)
            const localVarPath = `/proposal/validate/{templateId}/project/{entityId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityApi - functional programming interface
 * @export
 */
export const EntityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete details view
         * @param {Filter} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDetailsView(filter?: Filter, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDetailsView(filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Does the generation of a merged document
         * @param {GenerateMergeDocumentRequest} [generateMergeDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateMergeDocument(generateMergeDocumentRequest?: GenerateMergeDocumentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateMergeDocument(generateMergeDocumentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get details view data
         * @param {number} orgId 
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailsViews(orgId: number, entityTypeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailsViews(orgId, entityTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Downloads the merged document
         * @param {number} templateId TemplateId to use.
         * @param {number} entityId EntityId to use as the source of data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadMergeDocument(templateId: number, entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadMergeDocument(templateId, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a list of merged documents for the entity
         * @param {number} entityId EntityId to use as the source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMergeDocumentsDownloadList(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMergeDocumentsDownloadList(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a list of template documents for the merge documents dialog
         * @param {number} entityTypeId EntityTypeId to use as the source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMergeDocumentsTemplates(entityTypeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMergeDocumentsTemplates(entityTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validates the fields of merged documents for the entity
         * @param {number} templateId TemplateId to use.
         * @param {number} entityId EntityId to use as the source of data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateMergeDocuments(templateId: number, entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateMergeDocuments(templateId, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EntityApi - factory interface
 * @export
 */
export const EntityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete details view
         * @param {Filter} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDetailsView(filter?: Filter, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDetailsView(filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Does the generation of a merged document
         * @param {GenerateMergeDocumentRequest} [generateMergeDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMergeDocument(generateMergeDocumentRequest?: GenerateMergeDocumentRequest, options?: any): AxiosPromise<InlineResponse2003> {
            return localVarFp.generateMergeDocument(generateMergeDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details view data
         * @param {number} orgId 
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailsViews(orgId: number, entityTypeId: number, options?: any): AxiosPromise<InlineResponse20010> {
            return localVarFp.getDetailsViews(orgId, entityTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads the merged document
         * @param {number} templateId TemplateId to use.
         * @param {number} entityId EntityId to use as the source of data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadMergeDocument(templateId: number, entityId: number, options?: any): AxiosPromise<void> {
            return localVarFp.getDownloadMergeDocument(templateId, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of merged documents for the entity
         * @param {number} entityId EntityId to use as the source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergeDocumentsDownloadList(entityId: number, options?: any): AxiosPromise<InlineResponse2003> {
            return localVarFp.getMergeDocumentsDownloadList(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of template documents for the merge documents dialog
         * @param {number} entityTypeId EntityTypeId to use as the source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergeDocumentsTemplates(entityTypeId: number, options?: any): AxiosPromise<InlineResponse2003> {
            return localVarFp.getMergeDocumentsTemplates(entityTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validates the fields of merged documents for the entity
         * @param {number} templateId TemplateId to use.
         * @param {number} entityId EntityId to use as the source of data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMergeDocuments(templateId: number, entityId: number, options?: any): AxiosPromise<InlineResponse2004> {
            return localVarFp.validateMergeDocuments(templateId, entityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityApi - object-oriented interface
 * @export
 * @class EntityApi
 * @extends {BaseAPI}
 */
export class EntityApi extends BaseAPI {
    /**
     * 
     * @summary Delete details view
     * @param {Filter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public deleteDetailsView(filter?: Filter, options?: any) {
        return EntityApiFp(this.configuration).deleteDetailsView(filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Does the generation of a merged document
     * @param {GenerateMergeDocumentRequest} [generateMergeDocumentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public generateMergeDocument(generateMergeDocumentRequest?: GenerateMergeDocumentRequest, options?: any) {
        return EntityApiFp(this.configuration).generateMergeDocument(generateMergeDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details view data
     * @param {number} orgId 
     * @param {number} entityTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getDetailsViews(orgId: number, entityTypeId: number, options?: any) {
        return EntityApiFp(this.configuration).getDetailsViews(orgId, entityTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads the merged document
     * @param {number} templateId TemplateId to use.
     * @param {number} entityId EntityId to use as the source of data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getDownloadMergeDocument(templateId: number, entityId: number, options?: any) {
        return EntityApiFp(this.configuration).getDownloadMergeDocument(templateId, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of merged documents for the entity
     * @param {number} entityId EntityId to use as the source.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getMergeDocumentsDownloadList(entityId: number, options?: any) {
        return EntityApiFp(this.configuration).getMergeDocumentsDownloadList(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of template documents for the merge documents dialog
     * @param {number} entityTypeId EntityTypeId to use as the source.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public getMergeDocumentsTemplates(entityTypeId: number, options?: any) {
        return EntityApiFp(this.configuration).getMergeDocumentsTemplates(entityTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validates the fields of merged documents for the entity
     * @param {number} templateId TemplateId to use.
     * @param {number} entityId EntityId to use as the source of data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public validateMergeDocuments(templateId: number, entityId: number, options?: any) {
        return EntityApiFp(this.configuration).validateMergeDocuments(templateId, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}
